import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';
import { makeCss } from '../../make-css';

const useCss = makeCss({
  textField: {
    '& fieldset legend': {
      maxWidth: 0,
    },
  },
});

const InputTextField = ({ label, params, placeholder }) => {
  const css = useCss();
  return (
    <TextField
      {...params}
      css={css.textField}
      id={'autocomplete-text-field'}
      label={label}
      placeholder={placeholder}
      variant="outlined"
    />
  );
};

InputTextField.propTypes = {
  label: PropTypes.string,
  params: PropTypes.object,
  placeholder: PropTypes.string,
};

export default InputTextField;
